import angular from 'angular';
import Navigation from './navigation/navigation';
import ApiService from './apis/api';
import RegionService from './apis/regions';
import LivefeedService from './apis/livefeed';
import CategoryService from './apis/categories';
import WeatherService from './apis/weather';
import PhotosService from './apis/photos';
import AdsService from './apis/ads';
import TickerService from './apis/tickerService';
import WeatherVideoService from './apis/weatherVideoService';
import ClosingsAndDelays from './apis/closingsAndDelays';
import ProfileService from './apis/profile';
import NewsService from './apis/news';
import ArchiveService from './apis/archives';
import PollService from './apis/polls';
import './shared/photos';
import LocalService from './localService/localService';
import WeatherCurrentService from './apis/weatherCurrent';
import TrafficService from './apis/trafficService';
// Auth module
import './auth/authHelper';
import './auth/authInterceptor';
import Auth from './auth/auth';

const serviceModule = angular.module('app.services', [
  Navigation.name,
  ApiService.name,
  RegionService.name,
  LivefeedService.name,
  CategoryService.name,
  WeatherService.name,
  PhotosService.name,
  LocalService.name,
  Auth.name,
  ClosingsAndDelays.name,
  ProfileService.name,
  TickerService.name,
  NewsService.name,
  ArchiveService.name,
  PollService.name,
  ArchiveService.name,
  AdsService.name,
  WeatherVideoService.name,
  WeatherCurrentService.name,
  TrafficService.name
]);

export default serviceModule;



/** WEBPACK FOOTER **
 ** ./client/app/services/services.js
 **/